
export const BoardElementConfigHelpTexts = {
    selectElementType: 'data-lang-helptext-businesselemconfig-selectelementtype',
    selectVariableDataserie: 'data-lang-helptext-selectvariabledataserie',
    addVariableDataserie: 'data-lang-helptext-addvariabledataserie',
}

export const BoardCreacionHelpTexts = {
    selectElementType: 'data-lang-helptext-boardcreation-selectelementtype',
    selectElementsColor: 'data-lang-helptext-selectelementscolor',
    defaultTimeAggregation: 'data-lang-helptext-defaultTimeAggregation',
}

export const BoardHelpTexts = {
    processPosibleGapsDialog_Dataserie: 'data-lang-helptext-board-processposiblegaps-dataseries',
    processPosibleGapsDialog_Revision: 'data-lang-helptext-board-processposiblegaps-revisions',
    processPosibleGapsDialog_LinkedData: 'data-lang-helptext-board-processposiblegaps-linkeddata',

    
}

export const GapHelpTexts = {
    gapDataserieChartColor: 'data-lang-helptext-gap-gapDataserieChartColor',
    gapDataserieChartColorGreen: 'data-lang-helptext-gap-gapDataserieChartColor-green',
    gapDataserieChartColorPurple: 'data-lang-helptext-gap-gapDataserieChartColor-purple',
    gapDataserieChartColorRed: 'data-lang-helptext-gap-gapDataserieChartColor-red',
    gapDataserieChartColorBlue: 'data-lang-helptext-gap-gapDataserieChartColor-blue',
    gapDataserieChartColorGreenName: 'data-lang-helptext-gap-gapDataserieChartColor-greenName',
    gapDataserieChartColorPurpleName: 'data-lang-helptext-gap-gapDataserieChartColor-purpleName',
    gapDataserieChartColorRedName: 'data-lang-helptext-gap-gapDataserieChartColor-redName',
    gapDataserieChartColorBlueName: 'data-lang-helptext-gap-gapDataserieChartColor-blueName',
}